var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIonic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3880FF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "matrix(0.43537415,0,0,0.43537415,-16.631293,-79.368707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4",
    className: "st0",
    d: "M1188.2,816.6c-285.7,0-517.3,231.6-517.3,517.3s231.6,517.3,517.3,517.3s517.3-231.6,517.3-517.3 C1703.9,1048.2,1472.3,816.6,1188.2,816.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g8"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle6",
    className: "st0",
    cx: 1929.4,
    cy: 626.6,
    r: 236.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    className: "st0",
    d: "M2219.6,862.9l-9.3-21.6l-15.4,18.5c-38.6,43.2-88,77.2-142.1,97.3l-15.4,6.2l6.2,15.4 c47.9,112.7,71,233.2,71,355.1c0,511.1-415.4,928-928,928s-926.5-416.9-926.5-928s415.4-928,928-928c139,0,271.8,30.9,396.8,89.6 l13.9,6.2l6.2-15.4c23.2-54,58.7-100.4,105-137.4l18.5-15.4l-21.6-10.8c-162.1-83.4-336.6-126.6-520.4-126.6 C561.3,195.8,51.7,705.4,51.7,1330.7s509.6,1134.9,1134.9,1134.9s1134.9-509.6,1134.9-1134.9 C2321.6,1170.2,2287.6,1012.7,2219.6,862.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/ionic.1839709e7ebfee46c110ee83210d0efb.svg";
export { ForwardRef as ReactComponent };